import React from "react";
import { Formik, Field, Form } from "formik";
import {
  TextField,
  Loading,
  PersianDataPicker,
  RadioButton,
  TextArea,
} from "components/form";
import { required, validationWrapper, isUserName } from "lib/formValidations";
import {
  transformTranslateFromValues,
  transformTranslateServerValues,
  toDatePicker,
  dateTimeToserver,
} from "lib/helpers";
import Modal from "components/Modal";

// components

export default function ManageComment(props) {
  const { show, item } = props;
  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <div class="mt-3 text-center sm:mt-0 sm:mr-4 sm:text-right">
          <div class="mt-2">
            <p class="text-sm text-gray-900">
              کاربر:
              <br />
              {props.item && props.item.creator && props.item.creator.full_name}
              <br />
              {props.item && props.item.creator && props.item.creator.user_name}
            </p>
          </div>
          <div class="mt-2">
            <p class="text-sm text-gray-900">
              نظر:
              <br />
              {props.item && props.item.body}
            </p>
          </div>

          <div class="mt-2">
            <p class="text-sm text-gray-900">
              برای محصول:
              <br />
              {props.item.commentable && props.item.commentable.detail.title}
            </p>
          </div>

          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              disabled={props.load}
              onClick={props.accept}
              className="btn btn-primary w-20 mr-1"
            >
              تایید
            </button>
            <button
              type="button"
              disabled={props.load}
              onClick={props.delete}
              className="btn btn-outline-secondary w-20 mr-1"
            >
              حذف
            </button>
            <button
              type="button"
              disabled={props.load}
              onClick={props.close}
              className="btn btn-outline-secondary w-20 mr-1"
            >
              بستن
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
